import styled from "styled-components";

export const DateOfBirthContainer = styled.div`
  display: flex;
  flex-direction: ${({ $isMobile }) => (!$isMobile ? "row" : "column")};
  gap: 10px;
  width: 100%;
`;